const OFFSET = 67;

function onStudy() {
  $(window).scroll(function () {
    const stickyNav = $('.study-item__content-nav');
    const stickyContainer = $('.study-item__content-sticky-container');

    // Check if the navigation bar has become sticky
    if (stickyNav.css('position') === 'sticky' && stickyNav.offset().top <= $(window).scrollTop()) {
      stickyContainer.slideDown(300);
      stickyNav.css('padding-top', OFFSET + 'px');
    } else {
      stickyContainer.slideUp(100);
      stickyNav.css('padding-top', '');
    }
  });
}

export default onStudy;
